import {defineNuxtPlugin, useABTestStore} from '#imports';

/**
 * Used to fetch all campaigns automatically
 */
export default defineNuxtPlugin({
    name: 'global-abtest-plugin',
    parallel: true,
    dependsOn: ['backend-api-cookies', 'logger', 'fetch-auth'],
    async setup() {
        const {fetchCampaignsVariations} = useABTestStore();
        await fetchCampaignsVariations();
    },
});
